import React, { useState } from "react";
import { string } from "prop-types";

import Tooltip from "../../../../shared/seller-services/components/Tooltip";
import { useValuationStoreData } from "../../utilities/mobx/storeHooks";
import * as S from "./styled";

const ValuationMinimal = ({ className }) => {
  const {
    areaName,
    price,
    pricePerSquareFoot,
    pricePerSquareFootInArea,
    priceRangeEnd,
    priceRangeStart,
    rentPrice
  } = useValuationStoreData();

  const [isExpanded, setIsExpanded] = useState(false);

  const handleClick = () => setIsExpanded(!isExpanded);

  const fullContentWrapperId = "valuation-full-content";

  return (
    <S.ValuationContent className={className}>
      <S.Price>{price}</S.Price>
      <S.ValuationDetails id={fullContentWrapperId} isVisible={isExpanded}>
        <S.Label>
          <S.LabelText>Estimated Price Range: </S.LabelText>
          <S.Value>
            {priceRangeStart} - {priceRangeEnd}
          </S.Value>
        </S.Label>
        {pricePerSquareFoot && (
          <>
            <S.Spacer />
            <S.Label>
              <S.LabelText>Estimated Price per ft²: </S.LabelText>
              <S.Value>{pricePerSquareFoot}</S.Value>
            </S.Label>
          </>
        )}

        {pricePerSquareFootInArea && (
          <>
            <S.Spacer />
            <S.Label>
              <S.LabelText>Estimated Price per ft² in {areaName}: </S.LabelText>
              <S.Value>{pricePerSquareFootInArea} </S.Value>
            </S.Label>
          </>
        )}
        {rentPrice && (
          <>
            <S.Spacer />
            <S.Label>
              <S.LabelText>Estimated Rent: </S.LabelText>
              <S.Value>{rentPrice}</S.Value>/mo
              <S.TooltipContainer>
                <Tooltip title="Estimated Rent" titleVisible>
                  A Rent estimate is StreetEasy’s estimate of a property’s
                  monthly rental price. It is computed using a formula and is a
                  starting point in determining the monthly rental price for a
                  specific property.
                </Tooltip>
              </S.TooltipContainer>
            </S.Label>
          </>
        )}
        <S.Spacer />
      </S.ValuationDetails>
      <S.ViewMoreButton
        aria-controls={fullContentWrapperId}
        aria-expanded={isExpanded}
        onClick={handleClick}
      >
        {isExpanded ? "VIEW LESS" : "VIEW DETAILS"}
      </S.ViewMoreButton>
    </S.ValuationContent>
  );
};

ValuationMinimal.propTypes = {
  className: string
};

ValuationMinimal.defaultProps = {
  className: ""
};

export default ValuationMinimal;
